import React from "react";
import { useParams } from "react-router-dom";
import LocationDetails from "./LocationDetails";

export default function LocationDetailsWrapper(props) {
  const params = useParams();
  return <LocationDetails {...props} params={params} />;
}
